
import './App.css';

function App() {
  return (
    <div className="container-fluid bg-light min-vh-100 p-0">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary mb-4">
        <div className="container">
          <a className="navbar-brand fw-bold" href="#">Aerospace Forum</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link" href="#register">Register</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#login">Login</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#tools">Design Tools</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#forum">Forum</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="container mb-5">
        <div className="row align-items-center">
          <div className="col-md-7">
            <h1 className="display-5 fw-bold">Welcome to the Aerospace Forum</h1>
            <p className="lead">A community for amateur aircraft enthusiasts to share ideas in aerospace, including aircraft design, drones, UAVs, rockets, satellites, and more. Join us for a nominal subscription and connect with like-minded innovators!</p>
            <a href="#register" className="btn btn-primary btn-lg me-2">Register</a>
            <a href="#login" className="btn btn-outline-primary btn-lg">Login</a>
          </div>
          <div className="col-md-5 text-center">
            <img src="/airframe_design.jpeg" alt="Airframe Design" className="img-fluid" style={{maxHeight: '220px'}} />
          </div>
        </div>
      </div>

      {/* Disclaimer Section */}
      <div className="container mb-4" id="disclaimer">
        <div className="alert alert-warning">
          <h5 className="mb-2">Disclaimer</h5>
          <p>This disclaimer is only editable by the administrator. All members must read and accept this disclaimer before registration. <br /><span className="fst-italic">[Disclaimer text goes here]</span></p>
        </div>
      </div>

      {/* Registration & Login Section */}
      <div className="container mb-5" id="register">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card shadow-sm">
              <div className="card-body">
                <h4 className="card-title mb-3">Register</h4>
                <form>
                  <div className="mb-3">
                    <label htmlFor="regEmail" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="regEmail" placeholder="Enter email" required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="regPhone" className="form-label">Phone Number</label>
                    <input type="tel" className="form-control" id="regPhone" placeholder="Enter phone number" required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="regPassword" className="form-label">Password</label>
                    <input type="password" className="form-control" id="regPassword" placeholder="Password" required />
                  </div>
                  <div className="form-check mb-3">
                    <input className="form-check-input" type="checkbox" id="acceptDisclaimer" required />
                    <label className="form-check-label" htmlFor="acceptDisclaimer">
                      I have read and accept the disclaimer
                    </label>
                  </div>
                  <button type="submit" className="btn btn-success w-100">Register & Pay Subscription</button>
                  <div className="form-text mt-2">Registration is only completed after payment and disclaimer acceptance.</div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-6" id="login">
            <div className="card shadow-sm">
              <div className="card-body">
                <h4 className="card-title mb-3">Login</h4>
                <form>
                  <div className="mb-3">
                    <label htmlFor="loginEmail" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="loginEmail" placeholder="Enter email" required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="loginPassword" className="form-label">Password</label>
                    <input type="password" className="form-control" id="loginPassword" placeholder="Password" required />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">Login</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Aerospace Design Tools Section */}
      <div className="container mb-5" id="tools">
        <h3 className="mb-3">Aerospace Design & Analysis Tools</h3>
        <div className="row row-cols-1 row-cols-md-2 g-4">
          <div className="col">
            <div className="card h-100 border-info">
              <div className="card-body">
                <h5 className="card-title">CFD Tools</h5>
                <ul className="list-unstyled mb-0">
                  <li><a href="#" className="link-info">OpenFOAM (Free)</a></li>
                  <li><a href="#" className="link-info">ANSYS Fluent (Paid)</a></li>
                  <li><a href="#" className="link-info">SimScale (Free/Paid)</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100 border-info">
              <div className="card-body">
                <h5 className="card-title">FEM Analysis Tools</h5>
                <ul className="list-unstyled mb-0">
                  <li><a href="#" className="link-info">CalculiX (Free)</a></li>
                  <li><a href="#" className="link-info">Abaqus (Paid)</a></li>
                  <li><a href="#" className="link-info">COMSOL Multiphysics (Paid)</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100 border-info">
              <div className="card-body">
                <h5 className="card-title">Aerodynamic Analysis</h5>
                <ul className="list-unstyled mb-0">
                  <li><a href="#" className="link-info">XFLR5 (Free)</a></li>
                  <li><a href="#" className="link-info">AVL (Free)</a></li>
                  <li><a href="#" className="link-info">SU2 (Free)</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100 border-info">
              <div className="card-body">
                <h5 className="card-title">Control Design & Analysis</h5>
                <ul className="list-unstyled mb-0">
                  <li><a href="#" className="link-info">MATLAB/Simulink (Paid/Student)</a></li>
                  <li><a href="#" className="link-info">Scilab (Free)</a></li>
                  <li><a href="#" className="link-info">Octave (Free)</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="form-text mt-2">Links above include both paid and unpaid resources for aerospace design and analysis.</div>
      </div>

      {/* Forum Section */}
      <div className="container mb-5" id="forum">
        <h3 className="mb-3">Discussion Forums</h3>
        <div className="row g-4">
          <div className="col-md-8">
            <div className="card border-success mb-3">
              <div className="card-header bg-success text-white">Open Forum</div>
              <div className="card-body">
                <p className="card-text">Discuss your aerospace ideas and issues with the community. <span className="fst-italic">(Feature coming soon)</span></p>
              </div>
            </div>
            <div className="card border-secondary">
              <div className="card-header bg-secondary text-white">Private Forum <span className="badge bg-light text-dark ms-2">Admin Only</span></div>
              <div className="card-body">
                <p className="card-text">Private discussions are accessible only to the administrator. <span className="fst-italic">(Feature coming soon)</span></p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="alert alert-info">
              <strong>AI Misuse Prevention:</strong> Our AI tool actively monitors discussions to prevent misuse of the forum for non-aerospace topics or activities.
            </div>
          </div>
        </div>
      </div>

      {/* Company Offers Section */}
      <div className="container mb-5">
        <h3 className="mb-3">Sandbox Trials & Student Versions</h3>
        <div className="card border-primary">
          <div className="card-body">
            <p className="mb-1">Aerospace design tool companies can offer free trials or student versions of their software in a sandbox environment for serious enthusiasts. <span className="fst-italic">(Contact admin to participate)</span></p>
          </div>
        </div>
      </div>

      {/* Scalability Note */}
      <div className="container mb-5">
        <div className="alert alert-secondary">
          <strong>Scalability:</strong> This forum is designed to host up to <strong>10,000 members</strong> initially, with options for future upgrades and scalability as the community grows.
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-primary text-white text-center py-3 mt-auto">
        <div className="container">
          &copy; {new Date().getFullYear()} Aerospace Forum. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default App;
